/**
 * Canonical AISystem type — single source of truth.
 *
 * ALL codebases (client, functions, functions-ai) must import this type
 * from @officehub/shared. Do NOT define AISystem locally.
 *
 * When adding a new AI system:
 * 1. Add it here
 * 2. Add a label in AI_SYSTEM_LABELS
 * 3. npm run build in shared/
 * 4. Rebuild all consuming packages
 */

/** AI system types — which AI assistant this applies to */
export type AISystem =
  | "technician"
  | "office"
  | "crm"
  | "fleet"
  | "discovery"
  | "forms"
  | "chat"
  | "projects"
  | "processors"
  | "collections"
  | "workshop"
  | "recruiting";

/** All valid AISystem values as a readonly array (useful for iteration/validation) */
export const AI_SYSTEMS: readonly AISystem[] = [
  "technician",
  "office",
  "crm",
  "fleet",
  "discovery",
  "forms",
  "chat",
  "projects",
  "processors",
  "collections",
  "workshop",
  "recruiting",
] as const;

/** Display labels for each AI system */
export const AI_SYSTEM_LABELS: Record<AISystem, string> = {
  technician: "Technician AI",
  office: "Office AI",
  crm: "CRM AI",
  fleet: "Fleet AI",
  discovery: "Discovery AI",
  forms: "Forms AI",
  chat: "Chat AI",
  projects: "Projects AI",
  processors: "Processors",
  collections: "Collections",
  workshop: "Workshop AI",
  recruiting: "Recruiting AI",
};

/** Data domain types (for access control) */
export type DataDomain = "fleet" | "crm" | "billing" | "support" | "explorer" | "marketing";
